import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { resolveMediaUrl } from '../../../utilities/BL/QuizzB9Zone';

/**
 * COMPONENTE: QuizzB9Zone OVERLAY (DESIGN / CHILD VISUAL)
 * ------------------------------------------------------------------
 * Este componente maneja la visualización e interactividad del Overlay.
 * Renderiza dos códigos QR con coordenadas exactas para la dinámica
 * "Convivencia en la zona".
 * ------------------------------------------------------------------
 */
export function QuizzB9Zone({ flowState, offsetY, bannerImageMdUrl, bannerImageLgUrl }) {
    // ZERO-CANVAS RULE: No renderizar nada si está en estado 'idle'
    if (flowState === 'idle') return null;

    const qrValue = `${window.location.origin}/quizz-b9-zone?s=obs`;

    const mdSrc = bannerImageMdUrl ? resolveMediaUrl(bannerImageMdUrl) : '/img/overlays/rubaquiz/cintillo-ruba-1536-x-180-px.png';
    const lgSrc = bannerImageLgUrl ? resolveMediaUrl(bannerImageLgUrl) : '/img/overlays/rubaquiz/cintillo-ruba-1920-x-180-px.png';

    return (
        <div className="quizzb9zone-overlay" style={{ bottom: `${offsetY}px` }}>
            <div className={`quizzb9zone-overlay__banner quizzb9zone-overlay__banner--${flowState}`}>
                {/* 1536px and 1920px images */}
                <img 
                    src={mdSrc} 
                    className='quizzb9zone-overlay__banner__Image--Md' 
                    alt="Convivencia en la zona" 
                />
                <img 
                    src={lgSrc} 
                    className='quizzb9zone-overlay__banner__Image--Lg' 
                    alt="Convivencia en la zona Lg" 
                />
                
                {/* Left QR Code */}
                <div className='quizzb9zone-overlay__banner__QR-Overlay quizzb9zone-overlay__banner__QR-Overlay--left'>
                    <QRCodeSVG 
                        value={qrValue} 
                        size={256}
                        style={{ width: '92%', height: '92%', display: 'block' }}
                        bgColor={"#d9d9d9"} 
                        fgColor={"#000000"} 
                        level={"H"} 
                        imageSettings={{
                            src: "/img/overlays/rubaquiz/interaktia-transparent.png",
                            x: undefined,
                            y: undefined,
                            height: 52,
                            width: 52,
                            excavate: true, 
                        }}
                    />
                </div>

                {/* Right QR Code */}
                <div className='quizzb9zone-overlay__banner__QR-Overlay quizzb9zone-overlay__banner__QR-Overlay--right'>
                    <QRCodeSVG 
                        value={qrValue} 
                        size={256}
                        style={{ width: '92%', height: '92%', display: 'block' }}
                        bgColor={"#d9d9d9"} 
                        fgColor={"#000000"} 
                        level={"H"} 
                        imageSettings={{
                            src: "/img/overlays/rubaquiz/interaktia-transparent.png",
                            x: undefined,
                            y: undefined,
                            height: 52,
                            width: 52,
                            excavate: true, 
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default QuizzB9Zone;
